import { err_reconnect_timeout } from './utils';
import { Comet } from 'shared/api/comet/comets/abstract';
export class WebSocketComet extends Comet {
    _session_id = null;
    ws = null;
    mode_name() {
        return 'websocket';
    }
    session_id = () => {
        return this._session_id;
    };
    _get_url = () => {
        let url;
        if (window.ZONT_URL.websocket.indexOf('://') != -1) {
            url = window.ZONT_URL.websocket.replace(/^http/, 'ws');
        }
        else {
            const proto = window.location.protocol == 'https:' ? 'wss:' : 'ws:';
            url = `${proto}//${window.location.host}${window.ZONT_URL.websocket}`;
        }
        return (url +
            '?' +
            this.api.prepareGetArgs({
                data: this._session_id ? { session: this._session_id } : undefined,
            }, true));
    };
    start() {
        console.log(`Comet ${this.mode_name()} started`);
        this.stop();
        this.ws = new WebSocket(this._get_url(), 'zont-comet');
        this.ws.onopen = () => this.onConnected?.();
        this.ws.onmessage = (message) => {
            const messages = JSON.parse(message.data);
            for (const message of messages) {
                try {
                    this.processMessage(message);
                }
                catch (err) {
                    console.error(err);
                }
            }
        };
        this.ws.onerror = this.ws.onclose = () => {
            this.onConnectionLost?.();
            this.stop();
            if (this.active()) {
                this.testAuth().then();
                setTimeout(() => this.start(), err_reconnect_timeout());
            }
        };
    }
    processMessage(msg) {
        if (msg.event === '_comet_session') {
            this._session_id = msg.session;
        }
        else {
            return super.processMessage(msg);
        }
    }
    stop() {
        if (this.ws) {
            this.ws.onclose = null;
            this.ws.close();
            this.ws = null;
            this._session_id = null;
        }
    }
    async testAuth() {
        try {
            await this.api.test_auth();
        }
        catch ({ json, response }) {
            if (response?.status === 403) {
                this.authError();
            }
            else if (response?.status === 402) {
                // payment required
            }
            else {
                location.reload();
            }
        }
    }
}
